import { push } from 'react-router-redux';
import queryString from 'query-string';
import _ from 'lodash';
import crud from './crud';
import settings from '../../config/settings';
import routeUtils from '../../utils/routes';
import retrieveAffiliateInfoFromStorage from '../../utils/localStorage';
import { retrieveChannels, retrieveChannelSubscriptions } from './channels';
import { getStaffList } from '../../api/gems';

import {
  APP_DATA_LOADED,
  LOAD_SELECTED_AFFILIATE,
  API_LOADED_AFFILIATES,
  AFFILIATE_PRESELECTED,
  AFFILIATE_PRESELECTED_INCORRECT,
  RESET_AFFILIATE,
  API_LOADED_STAFFLIST,
} from '../types';

const navigateHome = function navigateHome() {
  return function navigateHomeFunction(dispatch, getState) {
    const {
      routing: {
        locationBeforeTransitions: {
          pathname,
        },
      },
    } = getState();
    let location = '/error404';
    const activeOnly = true;
    const routes = routeUtils.getRoutes(activeOnly);
    if (routes.length > 0 && routes[0].location) {
      location = routes[0].location;
    }
    if (pathname !== location) {
      dispatch(push(location));
    }
    document.body.dispatchEvent(new Event('app-navigate-home'));
  };
};

const storeAffiliateInfo = function storeAffiliateInfo(affiliateInfo) {
  window.localStorage.setItem('gems_affiliate', JSON.stringify(affiliateInfo));
};

const clearAffiliateInfo = function clearAffiliateInfo() {
  window.localStorage.removeItem('gems_affiliate');
};

// const retreiveAffiliateReservations = function retreiveAffiliateReservations(affiliateId, page) {
//   return function retreiveAffiliateReservationsFunction(dispatch) {
//     dispatch(crud.apiRead({
//       type: 'reservations',
//       urlParams: {
//         affiliateId,
//         page,
//       },
//     }))
//       .then((results) => {
//         if (results.links.next !== null && settings.enable_all_data_fetch === true) {
//           const params = queryString.parse(results.links.next.split('?')[1]);
//           dispatch(retreiveAffiliateReservations(affiliateId, params.page || null));
//         }
//       });
//   };
// };

const setStaffAvailability = function setStaffAvailability(affiliateId, userPermissionId, available = false) {
  return function setStaffAvailabilityFunction(dispatch) {
    const data = {
      type: 'user_permission',
      id: userPermissionId,
      attributes: {
        is_available: (available === true),
      },
    };
    return dispatch(crud.apiUpdate({
      type: 'user_permissions',
      urlParams: {
        affiliateId,
        userPermissionId,
        commands: '',
      },
      data,
    }));
  };
};

const retrieveAffiliateUserPermissions = function retrieveAffiliateUserPermissions(affiliateId) {
  return function retrieveAffiliateUserPermissionsFunction(dispatch, getState) {
    const {
      api: { user: { data: [user] } },
      routing: {
        locationBeforeTransitions: {
          pathname,
        },
      },
    } = getState();

    return dispatch(crud.apiRead({
      type: 'permissions',
      urlParams: {
        affiliateId,
        userId: user.id,
      },
    }))
      .then((perms) => {
        const isSuperUser = !!user.attributes.is_superuser;
        if (perms.data.length === 0 && !isSuperUser) {
          dispatch(push('/affiliates'));
        } else if (pathname === '/' || pathname === '/affiliates') {
          dispatch(navigateHome());
        }
      });
  };
};

const retrieveStaffList = () =>
  (dispatch, getState) => {
    const { affiliateId } = getState().session;

    return getStaffList(affiliateId).then(staffList =>
      dispatch({ type: API_LOADED_STAFFLIST, staffList }));
  };

const selectAffiliate = function selectAffiliate(affiliateId, singleAffiliate) {
  return function selectAffiliateFunction(dispatch, getState) {
    const { api: { affiliate } } = getState();
    let selectedAffiliateInfo = singleAffiliate;
    if (singleAffiliate === undefined) {
      selectedAffiliateInfo = _.find(
        affiliate.data,
        affiliateItem => (affiliateItem.id === affiliateId || affiliateItem.id.replace(/-/gi, '') === affiliateId),
      );
    }

    // update affiliate information in local storage
    const affiliateInfo = retrieveAffiliateInfoFromStorage();
    affiliateInfo.affiliateId = affiliateId;
    storeAffiliateInfo(affiliateInfo);

    dispatch({
      type: LOAD_SELECTED_AFFILIATE,
      payload: selectedAffiliateInfo,
    });

    return Promise.all([
      dispatch(retrieveStaffList(selectedAffiliateInfo.id)),
      dispatch(retrieveAffiliateUserPermissions(selectedAffiliateInfo.id))
        .then(() => dispatch(retrieveChannels()))
        .then(() => dispatch(retrieveChannelSubscriptions()))
        .then(() => dispatch({
          type: APP_DATA_LOADED,
          payload: {
            dataLoaded: true,
          },
        })),
    ]);
  };
};

const changeAffiliate = affiliateId => (dispatch, getState) => {
  const {
    affiliates: {
      selectedAffiliateInfo,
    },
  } = getState();

  let action;

  if (!selectedAffiliateInfo || selectedAffiliateInfo.id !== affiliateId) {
    dispatch({
      type: RESET_AFFILIATE,
      payload: {
        id: affiliateId,
      },
    });

    action = selectAffiliate(affiliateId);
  } else {
    action = navigateHome();
  }

  return dispatch(action);
};

const retrieveAffiliate = function retrieveAffiliate(affiliateId) {
  return function retrieveAffiliateFunction(dispatch) {
    dispatch(crud.apiRead({
      type: 'affiliate',
      urlParams: {
        affiliateId,
      },
    }))
      .then((singleAffiliate) => {
        dispatch(selectAffiliate(singleAffiliate.data.id, singleAffiliate.data));
      })
      .catch(() => {
        dispatch({
          type: AFFILIATE_PRESELECTED_INCORRECT,
          payload: {},
        });
        dispatch(push('/affiliates'));
      });
  };
};

const redirectAffiliate = function redirectAffiliate() {
  return function redirectAffiliateFunction(dispatch, getState) {
    const { api: { affiliate } } = getState();
    let selectedAffiliateInfo = null;
    const affiliateInfo = retrieveAffiliateInfoFromStorage();
    if (affiliate && affiliate.data.length > 1) {
      // retrieve affiliate information in local storage
      if (affiliateInfo.affiliateId) {
        selectedAffiliateInfo = _.find(affiliate.data, { id: affiliateInfo.affiliateId });
        if (!selectedAffiliateInfo) {
          dispatch(retrieveAffiliate(affiliateInfo.affiliateId));
          return;
        }
      } else {
        dispatch(push('/affiliates'));
        return;
      }
    } else if (affiliate && affiliate.data.length === 1) {
      selectedAffiliateInfo = affiliate.data[0];
    } else {
      dispatch(push('/unauthorized'));
      return;
    }
    dispatch(selectAffiliate(selectedAffiliateInfo.id, selectedAffiliateInfo));
  };
};

const retrieveAllAffiliates = function retrieveAllAffiliates(page) {
  return function retrieveAffiliatesFunction(dispatch, getState) {
    const { affiliates: { loaded } } = getState();
    return dispatch(crud.apiRead({
      type: 'affiliates',
      urlParams: {
        page,
      },
    }))
      .then((results) => {
        if (loaded === false && results.data) {
          dispatch({
            type: API_LOADED_AFFILIATES,
          });
        }
        if (results.links.next !== null && settings.enable_all_data_fetch === true) {
          const params = queryString.parse(results.links.next.split('?')[1]);
          return dispatch(retrieveAllAffiliates(params.page || null));
        }
        return Promise.resolve();
      });
  };
};

const retrieveAffiliateInfo = function retrieveAffiliateInfo() {
  return function retrieveAffiliateInfoFunction(dispatch) {
    const affiliateInfo = retrieveAffiliateInfoFromStorage();
    if (affiliateInfo.affiliateId) {
      dispatch({
        type: AFFILIATE_PRESELECTED,
        payload: {
          affiliateId: affiliateInfo.affiliateId,
        },
      });
    }
    return dispatch(retrieveAllAffiliates());
  };
};

export default {
  navigateHome,
  retrieveAffiliateInfo,
  clearAffiliateInfo,
  selectAffiliate,
  changeAffiliate,
  retrieveAllAffiliates,
  redirectAffiliate,
  retrieveStaffList,
  setStaffAvailability,
};



// WEBPACK FOOTER //
// ./src/state/actions/affiliates.js